import { includes } from 'ramda';

import { USER_ROLES } from 'constants/general';
import fetch from 'features/common/fetch';
import { getCurrentRole } from 'features/views/user/selectors';

import { setCampaignContactsSummary } from './slice';

export const startupCampaigns = () => (dispatch) => {
	dispatch(fetchCampaignContactsSummary());
};

export const fetchCampaignContactsSummary = () => (dispatch, getState) => {
	const currentRole = getCurrentRole(getState());
	const userIsSellerOrPPZ = includes(currentRole, [USER_ROLES.SELLER, USER_ROLES.PPZ]);

	userIsSellerOrPPZ &&
		dispatch(
			fetch.actions.get(fetch.constants.urls.campaignContactsSummary, {
				queryParams: { role: currentRole },
				onSuccess: [
					(response) => () => {
						const body = response?.body;
						dispatch(setCampaignContactsSummary(body));
					},
				],
			}),
		);
};
